<template>
<b-container>
    <b-card>
    <b-breadcrumb>
        <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
        <b-breadcrumb-item active>Send/Save Notification</b-breadcrumb-item>
    </b-breadcrumb>
    <b-alert variant="warning" :show="ward.twilio_test">
        Ward({{ward.ward_type}}) is currently in test mode, no messages will go out.
    </b-alert>
    <b-alert variant="warning" :show="notGsmMessage">
        Message Encoding is UCS which may result in higher text charges,
        Try changing the notification message, signature or greeting
    </b-alert>
    <b-row>
        <b-col>
    <h4>Send/Save Notification</h4>
        </b-col>
        <b-col>
    <b-card v-if="accountBalance !== null && accountBalance !== undefined">
        <h4>Twilio Balance: ${{accountBalance.balance.toFixed(2)}} {{accountBalance.currency}}</h4>
    </b-card>
    </b-col>
    </b-row>
        <b-form @submit="onSubmit">
        <b-form-group
            id="input-group-1"
            label="To Organization/Group:"
            label-for="input-1"
            description="Ward Organization/Group">
            <b-form-select
                id="input-1"
                v-model="selectedOrganization"
                :options="organizations"
                required
                @change="shouldShowLanguages"
            ></b-form-select>
        </b-form-group>
        <b-form-group
            id="input-group-2"
            label-for="input-2"
            description="Message to send to contacts.">
            <label for="input-2">Notification Message: Language [{{ defaultLanguage }}]
                <b-badge pill variant="info" v-if="total_segments>0">Segments: {{total_segments}}</b-badge>
                <b-badge pill variant="secondary" v-if="total_characters>0">Total Chars: {{total_characters}}</b-badge>
                </label>
            <b-form-textarea
              id="textarea"
              v-model="notificationText"
              placeholder="Enter Message to Send"
              rows="6"
              max-rows="6"
              @blur="validateMessageText"
              required
            ></b-form-textarea>
            <b-form-checkbox
                class="mb-3"
                v-model="shortenUrls"
                v-if="isInRole('canShortUrlMessages')"
                name="short-urls"
                switch>Shorten URLs
            </b-form-checkbox>
        </b-form-group>
        <h5>Message Options</h5>
        <p>Override defaults</p>
        <div>
          <b-card no-body>
            <b-tabs card vertical>
                <b-tab title="Custom Greeting" active><b-card-text>
                    <b-form-group
            id="input-group-3"
            label="Custom Greeting(Optional):"
            label-for="input-3"
            description="Custom Message Greeting to Contacts. Overrides Orginzation greeting">
            <b-form-textarea
              id="textarea"
              v-model="notificationGreeting"
              placeholder="Enter custom greeting of message."
              rows="2"
              max-rows="2"
              @blur="validateMessageText"
            ></b-form-textarea>
        </b-form-group>
                </b-card-text>
            </b-tab>
                <b-tab title="Custom Signature">
                    <b-card-text>        <b-form-group
            id="input-group-4"
            label="Custom Signature(Optional):"
            label-for="input-4"
            description="Custom Signature of message. Overrides Organization signature">
            <b-form-textarea
              id="textarea"
              v-model="notificationSignature"
              placeholder="Enter custom signature"
              rows="2"
              max-rows="2"
              @blur="validateMessageText"
            ></b-form-textarea>
        </b-form-group> </b-card-text>
                </b-tab>

                <b-tab title="Schedule Message">
                    <b-card-text>
                        <b-form-group
            id="input-group-5"
            label="Scheduled Delivery On(Optional):"
            description="Schedule the delivery message for a specific date/time"
        >
        <VueCtkDateTimePicker
            noLabel
            format="YYYY-MM-DDTHH:mm:ssZ"
            formatted="lll"
            minuteInterval=5
            :minDate="scheduleOnlyFuture"
            v-model="scheduleDeliveryOn"/>
            </b-form-group>
                    </b-card-text>
                </b-tab>


            <b-tab title="Extra phone numbers">
                    <b-card-text>
                        <b-form-group
            id="input-group-6"
            label="Include extra phone numbers not in contacts (Optional):"
            description="You can add additional numbers without creating/saving contacts."
            :state="tempContactsState"
        >
        <b-form-tags
            :formatter="formatPhoneNumber"
            :tag-validator="phoneNumberValidator"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            input-id="input-group-6"
            v-model="tempContacts"
            tag-variant="primary"
            tag-pills
            size="medium"
            separator=" ,;"
            placeholder="Enter phone numbers separate them by comma or semicolon."
            remove-on-delete
            :state="tempContactsState"
            ></b-form-tags>
            <template #invalid-feedback>
              Some of the phone numbers are invalid!
            </template>
            <template #description>
              <div id="tags-validation-help">
                  Phone numbers must be between 10 to 11 digits only and numeric only. Limit of 16 temporary contacts
              </div>
            </template>

        </b-form-group>
                    </b-card-text>
                </b-tab>
                <b-tab title="Additional Languages" v-if="showLanguages">
                    <b-card-text>
                    <b-tabs>
                        <b-tab v-for="(item, idx) of additionalLanguages" :title="item.tabName"
                        v-bind:key="item.tabName">
                            <b-card-text>
                                <b-form-group
            id="input-group-2"
            label-for="input-2"
            description="Message to send to contacts.">
            <label for="input-2">Notification Message:
                </label>
            <b-form-textarea
              id="textarea"
              v-model="item.notification_text"
              placeholder="Enter Message to Send"
              rows="6"
              max-rows="6"
            ></b-form-textarea>
            </b-form-group>
            <b-form-group
            id="input-group-3"
            label="Custom Greeting(Optional):"
            label-for="input-3"
            description="Custom Message Greeting to Contacts. Overrides Orginzation greeting">
            <b-form-textarea
              id="textarea"
              v-model="item.notification_greeting"
              placeholder="Enter custom greeting of message."
              rows="2"
              max-rows="2"
              @blur="validateMessageText"
            ></b-form-textarea>
        </b-form-group>
            <b-form-group
            id="input-group-4"
            label="Custom Signature(Optional):"
            label-for="input-4"
            description="Custom Signature of message. Overrides Organization signature">
            <b-form-textarea
              id="textarea"
              v-model="item.notification_signature"
              placeholder="Enter custom signature"
              rows="2"
              max-rows="2"
            ></b-form-textarea>
            </b-form-group>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card-text>
                </b-tab>
            </b-tabs>
          </b-card>
        </div>
        <b-form-checkbox class="mb-3 mt-3" v-model="sendConfirmed" v-if="!saveForLater && scheduleDeliveryOn===null" name="check-button" switch>
        Confirm Sending Message.
        </b-form-checkbox>
        <b-form-checkbox class="mb-3 mt-3" v-model="saveForLater" v-if="!sendConfirmed" name="check-button" switch>
        Save Message to Send Later
        </b-form-checkbox>
        <b-button
            type="submit"
            :disabled="disabledButton"
            variant="primary">
             <b-spinner small v-if="disabledButton"></b-spinner>
            {{submitText}}</b-button>
    </b-form>
    <b-modal ref="confirmation-modal" :title="sendConfirmed?'Message Summary':'Preview Summary'">
            <b-alert variant="warning" :show="notificationResponse.message_encoding==='UCS'">
                Message Encoding is UCS which may result in higher text charges,
                Try changing the notification message.
            </b-alert>
            <b-alert variant="warning" :show="shortenUrls">
                Message preview may contain shorten urls, those are NOT live links, please do not use.
            </b-alert>
            Ward({{ward.ward_type}}) Twilio Balance: <b-badge variant="info">${{notificationResponse.account_balance.toFixed(2)}}</b-badge><br/>
            Organization/Group: {{notificationResponse.organization}}<br/>
            Total Good Sent: {{notificationResponse.total_good}}<br/>
            Total Bad Sent: {{notificationResponse.total_bad}}<br/>
            Total Bytes: {{notificationResponse.total_bytes}}<br/>
            Total Segments: {{notificationResponse.total_segments}}<br/>
            Message Encoding: {{notificationResponse.message_encoding}}<br/>
            Sub Total Cost: {{notificationResponse.sub_total_cost}}<br/>
            Carrier Fees: {{notificationResponse.estimated_carrier_fee}}<br/>
            Total Cost: {{notificationResponse.total_cost}}<br/>
            <strong>{{sendConfirmed?'Message Sample':'Preview Message'}}:</strong>
            <pre>{{notificationResponse.message_preview}}</pre>
    </b-modal>
    <b-modal
        ref="error-modal"
        title="Error trying to send SMS"
        header-bg-variant="danger"
        ok-only>
            <strong>Error Code:{{error.code}}</strong>
            <pre>{{error.detail}}</pre>
    </b-modal>
    </b-card>
</b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { MessageApi } from "@/app/messages/messageApi";
import handleError from "@/errorHandler";
import { userMixin } from "@/mixins/userMixin";
import { organizationMixin } from "@/mixins/organizationMixin";
export default {
    name: "WardNotification",
    mixins: [userMixin, organizationMixin],
    props: {
        wardId: {
            type: String,
            required: false,
        },
        stakeId: {
            type: String,
            required: false
        },
        orgCode: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            notGsmMessage: false,
            total_segments: 0,
            total_characters: 0,
            disabledButton: false,
            notificationResponse: {
                account_balance: 0.0,
                estimated_carrier_fee: null,
                sub_total_cost: null,
            },
            selectedOrganization: null,
            notificationText: null,
            notificationGreeting: null,
            notificationSignature:null,
            costSummary:null,
            costDescription:null,
            sendConfirmed: false,
            scheduleDeliveryOn:null,
            tempContactsDirty: false,
            tempContacts: [],
            error: {
                code: null,
                detail: null
            },
            ward: {
                ward_name: null,
            },
            saveForLater: false,
            shortenUrls: false,
            showLanguages: false,
            additionalLanguages: [],
            defaultLanguage: 'None Selected',
            accountBalance: {
                balance: 0.00
            }
        };
    },
    computed: {
        submitText() {
            let buttonText = "";
            if(!this.disabledButton && !this.sendConfirmed)
                buttonText = "Preview SMS Notification";
            if(!this.disabledButton && this.sendConfirmed)
                buttonText = "Send SMS Notifications";
            if(this.disabledButton && this.sendConfirmed)
                buttonText = "Sending SMS Notification";
            if(this.disabledButton && !this.sendConfirmed)
                buttonText = "Generating SMS Preview";
            if(this.saveForLater && this.scheduleDeliveryOn===null)
                buttonText = "Save for Later"
            if(this.saveForLater && this.scheduleDeliveryOn!==null)
                buttonText = "Schedule for Later"
            return buttonText;
        },
        scheduleOnlyFuture() {
            let m = this.$moment();
            return m.format().replace("T", " ").slice(0,-6);
        },
        tempContactsState() {
            // Overall component validation state

            return this.tempContactsDirty ? (this.tempContacts.length < 16) : null
        },
        organizations() {
          let activeOrganizations = [];
            if (this.restrictedToOrgs.length > 0){
                activeOrganizations = this.allOrganizations.filter(opt => this.restrictedToOrgs.indexOf(opt.value) !== -1 && !opt.disabled);
            }else {
                activeOrganizations = this.allOrganizations.filter(opt => !opt.disabled);
            }
            if (activeOrganizations !== null && activeOrganizations.length === 0) {

              activeOrganizations.push({
                value: null,
                text: 'No organizations available for your user',
                disabled: true
              })
            }

            return activeOrganizations;


        }

    },
    watch: {
      tempContacts(newValue, oldValue) {
        // Set the dirty flag on first change to the tags array
        this.tempContactsDirty = true
      }
    },
    async mounted() {
        //console.log(this.stakeId)
        if(this.wardId !== null){
            this.selectedOrganization = this.orgCode;
            await this.getOrganizations(this.wardId);
            await this.getAccountBalance()
            await this.getWardDetails()
        }
    },
    methods: {
        phoneNumberValidator(phoneNumber) {
            // Individual tag validator function
            if (isNaN(phoneNumber)) return false;
            return phoneNumber.length === 10 || phoneNumber.length ===11;
        },
        formatPhoneNumber( value ) {
            if (value === null || value === undefined) return;
            let p = value.replace(/\D/g, '');
            let x = p.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length==11)
                x = p.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length===10){
                return  !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

            }
            if(p.length===11)
                return !x[3] ? x[2] : '(' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');



        },
        async getAccountBalance(){
            try{
                const { data } = await WardApi.getWardAccountBalance(this.wardId);
                this.accountBalance = data;
            }catch (e) {
                handleError(e, "Failed to get account balance")
            }
        },
        async getWardDetails(){
            try{
                const { data } = await WardApi.getWardDetail(this.wardId);
                //console.log(data);
                this.ward = data.ward;
            }catch (e) {
                handleError(e, "Failed to fetch ward details");
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            let dataToSend = {
                ward_id: this.wardId,
                notification_text: this.notificationText,
                notification_greeting: this.notificationGreeting,
                notification_signature: this.notificationSignature,
                organization: this.selectedOrganization,
                confirm_send: this.sendConfirmed,
                stake_id: this.stakeId,
                save_for_later: this.saveForLater,
                scheduled_delivery_on: this.scheduleDeliveryOn,
                temp_contacts: this.tempContacts,
                message_state: (this.scheduleDeliveryOn===null)? 'PENDING' : 'SCHEDULED',
                short_urls: this.shortenUrls,
                alternate_languages: this.additionalLanguages
            };
            try{
                this.disabledButton = true;
                const { data } = await WardApi.sendNotificationText(this.wardId, dataToSend);
                if(this.saveForLater){
                    this.$toast.success("Successfully saved message");
                    this.$router.push({ name: 'ward-message-list',params: { wardId: this.wardId, stakeId: this.stakeId, initState: dataToSend.message_state}});
                    return;
                }
                this.notificationResponse = data.NotificationResult;
                if(this.notificationResponse.message_preview==='Message has been queued for sending'){
                    this.$toast.success("Successfully Queued message for sending.");
                    this.$router.push({ name: 'ward-message-list',params: { wardId: this.wardId, stakeId: this.stakeId, initState: dataToSend.message_state}});
                    return;
                }

                this.sendConfirmed = false;
                this.$refs['confirmation-modal'].show();
            }catch(error){
                handleError(error, "Could not process message");
                //this.error.code = `${error.response.status}-${error.response.statusText}`;
                //this.error.detail = error.response.data.detail;
                //this.$refs['error-modal'].show();
            }finally{
                this.disabledButton = false;
            }
        },
        async validateMessageText() {
            if (this.selectedOrganization === undefined || this.notificationText === undefined || this.selectedOrganization === null || this.notificationText === null)
                return;
            let dataToSend = {
                ward_id: this.wardId,
                notification_text: this.notificationText,
                notification_greeting: this.notificationGreeting,
                notification_signature: this.notificationSignature,
                organization: this.selectedOrganization,
                confirm_send: this.sendConfirmed,
                stake_id: this.stakeId,
                save_for_later: this.saveForLater,
                scheduled_delivery_on: this.scheduleDeliveryOn,
                temp_contacts: this.tempContacts,
                message_state: (this.scheduleDeliveryOn===null)? 'PENDING' : 'SCHEDULED',
                short_urls: this.shortenUrls,
                alternate_languages: this.additionalLanguages
            };
            try {
              const {data} = await MessageApi.validateMessageText(dataToSend);
              if (data !== undefined || data !== null) {
                if (data.message_encoding !== 'GSM') {
                  this.notGsmMessage = true;
                } else {
                  this.notGsmMessage = false;
                }
                this.total_segments = data.segments;
                this.total_characters = data.total_chars;

              }
            } catch (error) {
                handleError(error, "Could not validate message");
              }

        },
        shouldShowLanguages() {
            this.additionalLanguages = [];
            if (this.selectedOrganization === null) {
                this.showLanguages = false;
            }
            let selectedOrg = this.organizations.find(x => x.value === this.selectedOrganization);
            this.defaultLanguage = selectedOrg.default_language;
            if (selectedOrg.message_languages.length === 0){
                this.showLanguages = false;
                this.additionalLanguages = [];
                return;
            }
            selectedOrg.message_languages.forEach((x)=> {
                this.additionalLanguages.push(
                    {
                        tabName: `Language: ${x}`,
                        language: x,
                        notification_greeting: null,
                        notification_text: null,
                        notification_signature: null
                    }
                );

            });
            this.showLanguages = true;

        }

    }
}
</script>
<style lang="scss" scoped>
</style>
